import { Component } from '@angular/core';
import { soundpostOrchestrationRunEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Orchestration Runs') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostorchestrationrun-form',
    templateUrl: './soundpostorchestrationrun.form.component.html'
})
export class soundpostOrchestrationRunFormComponent extends BaseFormComponent {
    public record!: soundpostOrchestrationRunEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'orchestrationRunSteps', sectionName: 'Orchestration Run Steps', isExpanded: false }
        ]);
    }
}

